import { render, staticRenderFns } from "./projectIntro.vue?vue&type=template&id=35c84e5e&scoped=true&"
import script from "./projectIntro.vue?vue&type=script&lang=js&"
export * from "./projectIntro.vue?vue&type=script&lang=js&"
import style0 from "./projectIntro.vue?vue&type=style&index=0&id=35c84e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c84e5e",
  null
  
)

export default component.exports